import angular from "angular";
import html from "./team_selection.html";

export default {
    templateUrl: html,
    controllerAs: "$ctrl",
    bindings: {
        selectedTeam: "<",
        teams: "<",
        onSelect: "&",
    },
    controller: function TeamSelect() {
        /////////////////////
        //
        //      Direct variables
        //
        /////////////////////

        var vm = this;

        /////////////////////
        //
        //      View model properties
        //
        /////////////////////

        /////////////////////
        //
        //      Lifecycle Hooks
        //          docu: https://toddmotto.com/angular-1-5-lifecycle-hooks
        //
        /////////////////////

        vm.$onInit = angular.noop;
        vm.$onChanges = angular.noop;
        vm.$onDestroy = angular.noop;

        /////////////////////
        //
        //      IMPL
        //
        /////////////////////
    },
};
